import { encrypt, decrypt } from './encodingdecoding';


export const encryptPayload = (body) => JSON.stringify({ data: encrypt(JSON.stringify(body)) });

export const decryptResponse = async (fetchResponse) => {
	let json;
	try {
		json = await fetchResponse.json();
	} catch (error) {
		return null;
	}

	if (fetchResponse.ok && json && typeof json.data === 'string') {
		try {
			return JSON.parse(decrypt(json.data));
		} catch (error) {
			return json;
		}
	}

	return json;
};

export const decryptAxiosData = (json) => {
	if (json && typeof json.data === 'string') {
		try {
			return JSON.parse(decrypt(json.data));
		} catch (error) {
			return json;
		}
	}

	return json;
};
